export class ListOrganizationAccountsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accounts",
            "baseName": "accounts",
            "type": "Array<OrganizationAccount>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListOrganizationAccountsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
